import { onMounted, onUnmounted } from 'vue'
import { useNavMenu } from './useNavMenu'

const TABLET_BREAKPOINT = 768

export function useNavClose(navRef) {
  const { isOpen, close, reset } = useNavMenu()

  const onResize = () => { if (window.innerWidth >= TABLET_BREAKPOINT) reset()}

  const onDocumentClick = (event) => {
    if (!isOpen.value) return
    const outsideNav = !navRef.value?.contains(event.target)
    const outsideButton = !event.target.closest('.site-header__actions')
    if (outsideNav && outsideButton) close()
  }

  onMounted(() => {
    window.addEventListener('resize', onResize)
    document.addEventListener('click', onDocumentClick)
  })
  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
    document.removeEventListener('click', onDocumentClick)
  })
}
